import PropTypes from "prop-types"
import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import TopNav from "./nav/TopNav"
import TopMainNav from "./nav/TopMainNav"
import { Link } from "gatsby"

function Header() {
  return (
    <div className="bg-blue-light">
      <TopNav />

      <div className={`m-3 text-center`}>
        <Link to="/">
          <StaticImage
            src="../images/dining-out-logo.png"
            alt="Dining Out Card"
          />
        </Link>
      </div>

      <TopMainNav />
    </div>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
